export const normalize = (value: number, min: number, max: number): number =>
  (value - min) / (max - min);
